import React, { useCallback, useEffect, useState } from 'react'
import { AppHeader } from 'src/business/components'
import { Box, Tab, Tabs } from '@mui/material'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { getWalletSummary } from 'src/business/services/APIs/CompanyCredits/companyCreditsApi'
import WalletSummary from './WalletSummary'
import WalletPolicy from './WalletPolicy'
import WalletTransactions from './WalletTransactions'
import WalletRecharge from './WalletRecharge'

export default function Wallet() {
  const [tab, setTab] = useState(0)
  const [summary, setSummary] = useState(null)
  const [summaryLoading, setSummaryLoading] = useState(true)

  const refreshSummary = useCallback(async () => {
    setSummaryLoading(true)
    try {
      const res = await getWalletSummary()
      if (res?.status === 200 && res?.data) setSummary(res.data)
    } finally {
      setSummaryLoading(false)
    }
  }, [])

  useEffect(() => {
    refreshSummary()
  }, [refreshSummary])

  return (
    <div>
      <AppHeader heading="Wallet & Credits" />
      <Box sx={{ px: { xs: 2, sm: 3 }, py: 2, maxWidth: 1200, margin: '0 auto' }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
          aria-label="Wallet sections"
        >
          <Tab id="wallet-tab-0" aria-controls="wallet-tabpanel-0" label="Summary" />
          <Tab id="wallet-tab-1" aria-controls="wallet-tabpanel-1" label="Policy" />
          <Tab id="wallet-tab-2" aria-controls="wallet-tabpanel-2" label="Transactions" />
          <Tab id="wallet-tab-3" aria-controls="wallet-tabpanel-3" label="Recharge" />
        </Tabs>

        <Box sx={{ minHeight: 200 }}>
          <Box
            role="tabpanel"
            hidden={tab !== 0}
            id="wallet-tabpanel-0"
            aria-labelledby="wallet-tab-0"
            sx={{ display: tab === 0 ? 'block' : 'none' }}
          >
            {summaryLoading ? (
              <LoadingSpinner bgColor="#F5F5F599" dark />
            ) : (
              <WalletSummary summary={summary} onRefresh={refreshSummary} />
            )}
          </Box>
          <Box
            role="tabpanel"
            hidden={tab !== 1}
            id="wallet-tabpanel-1"
            aria-labelledby="wallet-tab-1"
            sx={{ display: tab === 1 ? 'block' : 'none' }}
          >
            <WalletPolicy summary={summary} onRefresh={refreshSummary} />
          </Box>
          <Box
            role="tabpanel"
            hidden={tab !== 2}
            id="wallet-tabpanel-2"
            aria-labelledby="wallet-tab-2"
            sx={{ display: tab === 2 ? 'block' : 'none' }}
          >
            <WalletTransactions onRefresh={refreshSummary} />
          </Box>
          <Box
            role="tabpanel"
            hidden={tab !== 3}
            id="wallet-tabpanel-3"
            aria-labelledby="wallet-tab-3"
            sx={{ display: tab === 3 ? 'block' : 'none' }}
          >
            <WalletRecharge onRefresh={refreshSummary} />
          </Box>
        </Box>
      </Box>
    </div>
  )
}
